/**
 * given in bytes
 */
export const MAX_FILE_UPLOADED_SIZE = 50 * 1000000;

export const COMMON_DATE_TIME_FORMAT = "dd, MMM yyyy 'at' hh:mm";
export const COMMON_DATE_FORMAT = "dd, MMM yyyy";

export const BASE_URL = "/api";

export const emptyData = [];

export const LARAVEL_DATE_TIME_FORMAT = "yyyy-MM-dd HH:mm";

export const ORDER_STATUSES = [
  "awaiting_payment",
  "placed",
  "processing",
  "out_for_delivery",
  "ready_for_pick_up",
  "delivered",
  "cancelled",
  "failed",
];

export const USER_ROLES = [
  "super-administrator",
  "administrator",
  "manager",
  "salesman",
  "driver",
];

export const LIVE_CHAT_URL = "https://app.jivosite.com/";

export const IS_DEBUG =
  typeof import.meta.env.VITE_APP_ENV !== "undefined" &&
  import.meta.env.VITE_APP_ENV !== "production";

// export const PRIMARY_COLOR = "#ADA7D1";
export const PRIMARY_COLOR = "#7C648C";
export const SECONDARY_COLOR = "#D3AD9E";

export const APP_NAME = "Love Flowers";
export const APP_DESCRIPTION =
  "Fresh Flowers! Same Day Delivery! Better Flowers, Lower Prices! flowers wedding bouquet love family gift bride Florist Wedding florist Floral arrangements";

export const DELIVERY_TIMES = [
  "11:00 AM - 01:00 PM",
  "02:00 PM - 05:00 PM",
  "05:00 PM - 08:30 PM",
];

export const IN_STORE_PICK_UP_TIMES = [
  "10:30 AM",
  "11:00 AM",
  "11:30 AM",
  "12:00 PM",
  "12:30 PM",
  "01:00 PM",
  "01:30 PM",
  "02:00 PM",
  "02:30 PM",
  "03:00 PM",
  "03:30 PM",
  "04:00 PM",
  "04:30 PM",
  "05:00 PM",
  "05:30 PM",
  "06:00 PM",
  // "06:30 PM",
  "07:00 PM",
  "08:00 PM",
  "08:30 PM",
];

export const COUPON_TYPES = [
  "discount",
  "free_shipping",
  "free_shipping_and_discount",
];
export const COUPON_VALUE_TYPES = ["amount", "percent"];
export const CUSTOMER_LIMIT_OPTIONS = ["No limit", "repeat", "new"];
export const NUMBER_OF_USES_OPTIONS = [
  "No limit",
  "once_per_customer",
  "single_use",
];

export const TIP_OPTIONS = [2, 5, 10, 20];
